"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const foundation_settings_1 = require("@episerver/foundation-settings");
const just_debounce_it_1 = __importDefault(require("just-debounce-it"));
const spa_core_1 = require("@episerver/spa-core");
const Shareticker = ({ layoutSettings, bgcolorClass, desktopVersion }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    const settingsService = (0, foundation_settings_1.useSettings)();
    const [navigationSettings] = (0, react_1.useState)(settingsService.getContainerOnServer('Navigation'));
    const [scrollClass, setScrollClass] = (0, react_1.useState)('');
    const [scrollPos, setScrollPos] = (0, react_1.useState)(0);
    const [openClass, setOpenClass] = (0, react_1.useState)('');
    const [stockTickerHint, setStockTickerHint] = (0, react_1.useState)(spa_core_1.ContentDelivery.namePropertyIsString(layoutSettings.stockTickerAccessibilityName) ? layoutSettings.stockTickerAccessibilityName : (_a = layoutSettings.stockTickerAccessibilityName) === null || _a === void 0 ? void 0 : _a.value);
    const mobileStockUp = spa_core_1.ContentDelivery.namePropertyIsString(layoutSettings.stockIconUp) ? layoutSettings.stockIconUp : (_b = layoutSettings.stockIconUp) === null || _b === void 0 ? void 0 : _b.value;
    const stockUpHint = spa_core_1.ContentDelivery.namePropertyIsString(layoutSettings.stockIconUpLabel) ? layoutSettings.stockIconUpLabel : (_c = layoutSettings.stockIconUpLabel) === null || _c === void 0 ? void 0 : _c.value;
    const mobileStockDown = spa_core_1.ContentDelivery.namePropertyIsString(layoutSettings.stockIconDown) ? layoutSettings.stockIconDown : (_d = layoutSettings.stockIconDown) === null || _d === void 0 ? void 0 : _d.value;
    const stockDownHint = spa_core_1.ContentDelivery.namePropertyIsString(layoutSettings.stockIconDownLabel) ? layoutSettings.stockIconDownLabel : (_e = layoutSettings.stockIconDownLabel) === null || _e === void 0 ? void 0 : _e.value;
    const stockTickerHrefHint = spa_core_1.ContentDelivery.namePropertyIsString(layoutSettings.shareTickerHrefAccessibilityHint) ? layoutSettings.shareTickerHrefAccessibilityHint : (_f = layoutSettings.shareTickerHrefAccessibilityHint) === null || _f === void 0 ? void 0 : _f.value;
    const [sharePrices, setSharePrices] = (0, react_1.useState)({
        sharePrice: (_g = navigationSettings === null || navigationSettings === void 0 ? void 0 : navigationSettings.sharePrice) === null || _g === void 0 ? void 0 : _g.sharePrice,
        percentageChange: (_h = navigationSettings === null || navigationSettings === void 0 ? void 0 : navigationSettings.sharePrice) === null || _h === void 0 ? void 0 : _h.percentageChange,
        arrow: ((_j = navigationSettings === null || navigationSettings === void 0 ? void 0 : navigationSettings.sharePrice) === null || _j === void 0 ? void 0 : _j.arrow) === 'stockDown' ? 'icon-rate-down' : 'icon-rate-up',
        arrowHint: ((_k = navigationSettings === null || navigationSettings === void 0 ? void 0 : navigationSettings.sharePrice) === null || _k === void 0 ? void 0 : _k.arrow) === 'stockDown' ? stockDownHint : stockUpHint,
        timeStamp: (_l = navigationSettings === null || navigationSettings === void 0 ? void 0 : navigationSettings.sharePrice) === null || _l === void 0 ? void 0 : _l.timeStamp
    });
    bgcolorClass = bgcolorClass && bgcolorClass !== '' ? bgcolorClass : 'ticker-white';
    const debouncedCloseShare = (0, just_debounce_it_1.default)(() => {
        setOpenClass('');
    }, 1000);
    const closeShareOnScroll = () => {
        if (scrollPos > 0 && Math.abs(window.scrollY - scrollPos) > 200) {
            debouncedCloseShare();
            setScrollPos(0);
        }
    };
    const whenScrolling = () => {
        const viewport = window.innerWidth;
        const image = document.querySelector('.page-image') !== null ? document.querySelector('.page-image') : document.querySelector('.bg-map');
        if (image) {
            const pointOfDisappear = viewport < 576 ? image.clientHeight - document.querySelector('header').clientHeight + 54 : 20;
            window.scrollY > pointOfDisappear ? setScrollClass('scrolled') : setScrollClass('');
        }
    };
    const showShare = () => {
        debouncedCloseShare.cancel();
        setOpenClass('open');
        setScrollPos(window.scrollY);
    };
    (0, react_1.useEffect)(() => {
        var _a;
        const updateShare = () => {
            if ((desktopVersion === undefined && window.innerWidth < 860) || (desktopVersion && window.innerWidth > 859.8)) {
                settingsService.getSharePrice().then((x) => {
                    if (x === null || x === void 0 ? void 0 : x.sharePrice) {
                        setSharePrices({
                            sharePrice: x.sharePrice,
                            percentageChange: x.percentageChange,
                            arrow: (x === null || x === void 0 ? void 0 : x.arrow) === 'stockDown' ? 'icon-rate-down' : 'icon-rate-up',
                            arrowHint: (x === null || x === void 0 ? void 0 : x.arrow) === 'stockDown' ? stockDownHint : stockUpHint,
                            timeStamp: x.timeStamp
                        });
                    }
                });
            }
        };
        updateShare();
        let intervalID;
        const interval = ((typeof (layoutSettings === null || layoutSettings === void 0 ? void 0 : layoutSettings.stockPriceUpdateInterval) === 'number' ? layoutSettings.stockPriceUpdateInterval : (_a = layoutSettings.stockPriceUpdateInterval) === null || _a === void 0 ? void 0 : _a.value) || 0) * 1000;
        if (interval > 0) {
            intervalID = setInterval(updateShare, interval);
        }
        if (desktopVersion === undefined)
            window.addEventListener('scroll', whenScrolling);
        setStockTickerHint(stockTickerHint && stockTickerHint !== '' ?
            `${stockTickerHint} (${sharePrices === null || sharePrices === void 0 ? void 0 : sharePrices.sharePrice} ${sharePrices === null || sharePrices === void 0 ? void 0 : sharePrices.percentageChange}). ${stockTickerHrefHint && stockTickerHrefHint !== '' ? stockTickerHrefHint : null}`
            : null);
        return () => {
            window.removeEventListener('scroll', whenScrolling);
            clearInterval(intervalID);
        };
    }, []);
    (0, react_1.useEffect)(() => {
        if (scrollPos > 0 && desktopVersion === undefined)
            window.addEventListener('scroll', closeShareOnScroll);
        return () => {
            window.removeEventListener('scroll', closeShareOnScroll);
        };
    }, [scrollPos]);
    return (react_1.default.createElement("div", { className: `col-md-12 pt-md-6 pb-md-0 px-md-6 shareticker ${bgcolorClass} ${scrollClass} ${openClass}` },
        react_1.default.createElement("button", { className: 'border-0 open-btn d-md-none', onClick: () => showShare() },
            react_1.default.createElement("span", { className: 'visually-hidden' },
                react_1.default.createElement(spa_core_1.Components.Property, { iContent: layoutSettings, field: "showStockAccessibilityHint" })),
            react_1.default.createElement("span", { "aria-hidden": 'true', className: `${mobileStockUp && mobileStockDown ? (sharePrices === null || sharePrices === void 0 ? void 0 : sharePrices.arrow) === 'icon-rate-down' ? mobileStockDown : mobileStockUp : sharePrices === null || sharePrices === void 0 ? void 0 : sharePrices.arrow} share-arrow fw-bold` },
                react_1.default.createElement("span", { className: 'visually-hidden' }, sharePrices === null || sharePrices === void 0 ? void 0 : sharePrices.arrowHint))),
        react_1.default.createElement("a", { href: (_m = layoutSettings.shareTickerHref) === null || _m === void 0 ? void 0 : _m.value, className: 'price-wrapper', "aria-label": stockTickerHint },
            react_1.default.createElement("span", { className: 'pe-2' }, sharePrices === null || sharePrices === void 0 ? void 0 : sharePrices.sharePrice),
            react_1.default.createElement("span", { className: 'fw-bolder pe-2' }, sharePrices === null || sharePrices === void 0 ? void 0 : sharePrices.percentageChange),
            react_1.default.createElement("span", { className: `${sharePrices === null || sharePrices === void 0 ? void 0 : sharePrices.arrow} share-arrow fw-bold` },
                react_1.default.createElement("span", { className: 'visually-hidden' }, sharePrices === null || sharePrices === void 0 ? void 0 : sharePrices.arrowHint)))));
};
exports.default = Shareticker;
